// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"HL-z","carouselContainer":"IL-z"};